<template>
  <div>
    <b-button
      :disabled="isPDFDisabled"
      id="btn_search"
      variant="primary"
      class="btn btn-label btn-primary float-right"
      @click="pdfgen"
      ><i class="bx bxs-file-pdf label-icon"></i>Download PDF</b-button
    >
  </div>
</template>

<script>
import { logo } from '../../assets/images/kaliLogo.js';
import moment from 'moment';

export default {
  name: 'ReportsPDF',
  components: {},
  props: {
    tableData: Array,
    reportTotals: Array,
    productTableData: Array,
    productReportTotals: Array,
    procurementTableData: Array,
    procurementReportTotals: Array,
    searchCustomer: String,
    searchProduct: String,
    searchJobNum: Number,
    searchStartDate: Date,
    searchEndDate: Date,
    searchEmployee: String,
    showProducts: Boolean,
    showProcurements: Boolean,
  },
  data() {
    return {
      isPDFDisabled: true,
    };
  },
  methods: {
    pdfgen: function() {
      var pdfMake = require('pdfmake/build/pdfmake.js');
      var pdfFonts = require('pdfmake/build/vfs_fonts.js');
      pdfMake.vfs = pdfFonts.pdfMake.vfs;

      var docDefinition = {
        content: [
          {
            table: {
              widths: ['*', 'auto'],
              body: [
                [
                  {
                    text: this.getHeader(),
                    style: 'header',
                    border: [false, false, false, true],
                  },
                  {
                    image: logo,
                    style: 'logo',
                    fit: [100, 100],
                    border: [false, false, false, true],
                  },
                ],
              ],
            },
          },
          '\n\n',
          this.getEmployee(),
          '\n\n',
          {
            columns: [
              { width: '*', text: 'Customer', style: 'subheader' },
              { width: '*', text: 'Product', style: 'subheader' },
              { width: '*', text: 'Job #', style: 'subheader' },
              { width: '*', text: 'Start Date', style: 'subheader' },
              { width: '*', text: 'End Date', style: 'subheader' },
            ],
          },
          '\n',
          {
            columns: [
              { width: '*', text: this.searchCustomer, style: 'subheader2' },
              { width: '*', text: this.searchProduct, style: 'subheader2' },
              { width: '*', text: this.searchJobNum, style: 'subheader2' },
              { width: '*', text: this.startDate, style: 'subheader2' },
              { width: '*', text: this.endDate, style: 'subheader2' },
            ],
          },
          '\n\n',

          { text: 'Hours', style: 'header', alignment: 'center' },
          '\n\n',

          {
            columns: [
              { width: '*', text: 'Hours Worked', style: 'subheader' },
              { width: '*', text: 'Days Worked', style: 'subheader' },
              { width: '*', text: 'Regular Hours', style: 'subheader' },
              { width: '*', text: 'Overtime Hours', style: 'subheader' },
              { width: '*', text: 'Travel Hours', style: 'subheader' },
            ],
          },
          '\n',
          {
            columns: [
              {
                width: '*',
                text: this.reportTotals[0].value,
                style: 'subheader2',
              },
              {
                width: '*',
                text: this.reportTotals[1].value,
                style: 'subheader2',
              },
              {
                width: '*',
                text: this.reportTotals[2].value,
                style: 'subheader2',
              },
              {
                width: '*',
                text: this.reportTotals[3].value,
                style: 'subheader2',
              },
              {
                width: '*',
                text: this.reportTotals[4].value,
                style: 'subheader2',
              },
            ],
          },
          '\n\n',
          {
            columns: [
              { width: '*', text: 'Total Labour Revenue', style: 'subheader' },
              { width: '*', text: 'Total Payroll Paid', style: 'subheader' },
            ],
          },
          '\n',
          {
            columns: [
              {
                width: '*',
                text: `$${this.reportTotals[5].value}`,
                style: 'subheader2',
              },
              {
                width: '*',
                text: `$${this.reportTotals[6].value}`,
                style: 'subheader2',
              },
            ],
          },
          '\n\n',

          {
            columns: [
              {
                width: '*',
                text: '',
              },
              {
                width: 'auto',
                table: {
                  headerRows: 1,
                  body: this.buildTable(),
                  style: 'table',
                },
              },
              {
                width: '*',
                text: '',
              },
            ],
            pageBreak: 'after',
          },
          '\n\n',
          this.showProducts
            ? {
                text: 'Products',
                style: 'header',
                alignment: 'center',
              }
            : '',
          '\n\n',
          this.showProducts
            ? {
                columns: [
                  {
                    width: '*',
                    text: 'Amount of Products Sold',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Amount of Days Products Sold',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Total Product Revenue',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Total Paid for Products',
                    style: 'subheader',
                  },
                ],
              }
            : '',
          '\n',
          this.showProducts
            ? {
                columns: [
                  {
                    width: '*',
                    text: this.productReportTotals[0].value,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: this.productReportTotals[1].value,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: `$${this.productReportTotals[2].value}`,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: `$${this.productReportTotals[3].value}`,
                    style: 'subheader2',
                  },
                ],
              }
            : '',
          '\n',
          this.showProducts
            ? {
                columns: [
                  {
                    width: '*',
                    text: '',
                  },
                  {
                    width: 'auto',
                    table: {
                      headerRows: 1,
                      body: this.buildProductsTable(),
                      style: 'table',
                    },
                  },
                  {
                    width: '*',
                    text: '',
                  },
                ],
                pageBreak: 'after',
              }
            : '',
          this.showProcurements
            ? { text: 'Procurements', style: 'header', alignment: 'center' }
            : '',
          '\n\n',
          this.showProcurements
            ? {
                columns: [
                  {
                    width: '*',
                    text: 'Amount of Procurements',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Total Procurement Expense',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Total Procurement Revenue',
                    style: 'subheader',
                  },
                  {
                    width: '*',
                    text: 'Total Procurement Profit',
                    style: 'subheader',
                  },
                ],
              }
            : '',
          '\n',
          this.showProcurements
            ? {
                columns: [
                  {
                    width: '*',
                    text: this.procurementReportTotals[0].value,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: `$${this.procurementReportTotals[1].value}`,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: `$${this.procurementReportTotals[2].value}`,
                    style: 'subheader2',
                  },
                  {
                    width: '*',
                    text: `$${this.procurementReportTotals[3].value}`,
                    style: 'subheader2',
                  },
                ],
              }
            : '',
          '\n',
          this.showProcurements
            ? {
                columns: [
                  {
                    width: '*',
                    text: '',
                  },
                  {
                    width: 'auto',
                    table: {
                      headerRows: 1,
                      body: this.buildProcurementsTable(),
                      style: 'table',
                    },
                  },
                  {
                    width: '*',
                    text: '',
                  },
                ],
              }
            : '',
        ],
        pageOrientation: 'landscape',
        styles: {
          header: {
            fontSize: 25,
            bold: true,
            alignment: 'left',
          },
          subheader: {
            fontSize: 18,
            bold: true,
            alignment: 'center',
            color: '#556ee6',
          },
          subheader2: {
            fontSize: 13,
            bold: true,
            alignment: 'center',
          },
          employeeName: {
            fontSize: 22,
            bold: true,
            alignment: 'center',
            decoration: 'underline',
          },
          table: {
            width: '*',
          },

          logo: { alignment: 'center' },
        },
      };

      let pdfFileTitle = this.searchEmployee
        ? `${this.searchEmployee} Employee Hours Report`
        : `Hours Worked Report`;

      pdfMake.createPdf(docDefinition).download(pdfFileTitle);
    },
    buildTable: function() {
      if (this.searchEmployee) {
        let body = [
          ['Date', 'Customer', 'Job', 'Description', 'Hours', 'Billable'],
        ];
        this.tableData.forEach((item) => {
          body.push([
            item.Date ? item.Date : null,
            item.Customer ? item.Customer : null,
            item.Job ? item.Job : null,
            item.Description ? item.Description : null,
            item.Hours ? item.Hours : null,
            item.Billable ? 'Yes' : 'No',
          ]);
        });
        return body;
      } else {
        let body = [
          [
            'Date',
            'Job #',
            'Customer',
            'Employee',
            'Description',
            'Hours',
            'Rate',
            'Employee Rate',
            'Billable',
          ],
        ];

        this.tableData.forEach((item) => {
          body.push([
            item.Date ? item.Date : null,
            item.Job ? item.Job : null,
            item.Customer ? item.Customer : null,
            item.Employee ? item.Employee : null,
            item.Description ? item.Description : null,
            item.Hours ? item.Hours : null,
            item.Rate ? item.Rate : null,
            item.PayrollRate ? item.PayrollRate : null,
            item.Billable ? 'Yes' : 'No',
          ]);
        });
        return body;
      }
    },
    buildProductsTable: function() {
      if (this.showProducts) {
        let body = [
          [
            'Date',
            'Employee',
            'Customer',
            'Job',
            'Product',
            'Quantity',
            'Rate',
            'Purchase Price',
            'Billable',
          ],
        ];
        this.productTableData.forEach((item) => {
          body.push([
            item.Date ? item.Date : null,
            item.Employee ? item.Employee : null,
            item.Customer ? item.Customer : null,
            item.Job ? item.Job : null,
            item.Product ? item.Product : null,
            item.Quantity ? item.Quantity : null,
            item.Rate ? item.Rate : null,
            item.PurchasePrice ? item.PurchasePrice : null,
            item.Billable ? 'Yes' : 'No',
          ]);
        });
        return body;
      } else {
        return null;
      }
    },
    buildProcurementsTable: function() {
      try {
        if (this.showProcurements) {
          let body = [
            [
              'Date',
              'Job Num',
              'Name',
              'Customer',
              'Quoted Amount',
              'Received Amount',
              'RateMark-Up',
              'Type',
              'Ordered',
              'Received',
              'Invoiced',
              'Billable',
            ],
          ];
          this.procurementTableData.forEach((item) => {
            body.push([
              item.date ? moment(item.date).format('MMM DD, YY') : null,
              item.jobNum ? item.jobNum : null,
              item.name ? item.name : null,
              item.customer ? item.customer : null,
              item.quotedAmount ? item.quotedAmount : null,
              item.receivedAmount ? item.receivedAmount : null,
              item.markup ? item.markup : null,
              item.markupType ? item.markupType : null,
              item.ordered ? (item.ordered.value ? 'Yes' : 'No') : null,
              item.received ? (item.received.value ? 'Yes' : 'No') : null,
              item.invoiced ? (item.invoiced.value ? 'Yes' : 'No') : null,
              item.billable ? (item.billable.value ? 'No' : 'Yes') : null,
            ]);
          });
          return body;
        } else {
          return null;
        }
      } catch (err) {
        console.log('Error generating procurements table');
      }
    },
    getHeader() {
      return 'Cost Vs Earnings Report';
    },
    getEmployee() {
      if (this.searchEmployee) {
        return { text: this.searchEmployee, style: 'employeeName' };
      }
    },
  },
  computed: {
    startDate() {
      if (this.searchStartDate) {
        return this.searchStartDate.toString().substring(0, 15);
      } else {
        return null;
      }
    },
    endDate() {
      if (this.searchEndDate) {
        return this.searchEndDate.toString().substring(0, 15);
      } else {
        return null;
      }
    },
  },
  watch: {
    tableData: function(val) {
      if (val.length > 1) {
        this.isPDFDisabled = false;
      } else {
        this.isPDFDisabled = true;
      }
    },
    searchJobNum: function() {
      this.isPDFDisabled = true;
    },
    searchEmployee: function() {
      this.isPDFDisabled = true;
    },
    searchStartDate: function() {
      this.isPDFDisabled = true;
    },
    searchEndDate: function() {
      this.isPDFDisabled = true;
    },
    searchCustomer: function() {
      this.isPDFDisabled = true;
    },
  },
};
</script>

<style scoped></style>
